/**
 * Catálogo unificado de planos MyLegis (Plano B).
 *
 * - Web: Pagar.me (`pagarmePlanId`)
 * - iOS/Android: In-App Purchase / Play Billing (`storeProductId`)
 * - Entitlement compartilhado: `users.plano` (`code`)
 *
 * Os `storeProductId` são placeholders até criar os produtos no
 * App Store Connect e no Google Play Console. Mantenha o mesmo ID
 * nas duas lojas quando possível.
 */

export const BILLING_PLANS = [
	{
		code: 'plano-free',
		title: 'Plano Iniciante',
		priceLabel: 'Grátis',
		priceCents: 0,
		storageLabel: '10MB',
		pagarmePlanId: 'plan_free',
		storeProductId: null,
		purchasable: false,
		route: '/cadastro/plano-free',
	},
	{
		code: 'plano-carreira',
		title: 'Plano Carreira',
		priceLabel: 'R$ 14,90',
		priceCents: 1490,
		storageLabel: '10GB',
		pagarmePlanId: 'plan_48jmqoxfpH5OzQ0P',
		storeProductId: 'com.mylegis.app.plano_carreira_monthly',
		purchasable: true,
		route: '/cadastro/plano-carreira',
	},
	{
		code: 'plano-premium',
		title: 'Plano Premium',
		priceLabel: 'R$ 49,90',
		priceCents: 4990,
		storageLabel: '50GB',
		pagarmePlanId: 'plan_vZJkelpIwIyeNq1M',
		storeProductId: 'com.mylegis.app.plano_premium_monthly',
		purchasable: true,
		route: '/cadastro/plano-premium',
	},
	{
		code: 'plano-legislativo',
		title: 'Plano Legislativo',
		priceLabel: 'R$ 499,90',
		priceCents: 49990,
		storageLabel: null,
		pagarmePlanId: 'plan_g3180ooh6OSo0Wzx',
		storeProductId: 'com.mylegis.app.plano_legislativo_monthly',
		purchasable: true,
		route: '/cadastro/plano-legislativo',
	},
	{
		code: 'plano-patrocinio',
		title: 'Plano Patrocínio',
		priceLabel: 'R$ 89,90',
		priceCents: 8990,
		storageLabel: null,
		pagarmePlanId: 'plan_lay6XlycO4TJw6e1',
		storeProductId: 'com.mylegis.app.plano_patrocinio_monthly',
		purchasable: true,
		route: '/cadastro/plano-patrocinio',
	},
];

export function getPlanByCode(code) {
	return BILLING_PLANS.find((plan) => plan.code === code) || null;
}

export function getPlanByPagarmeId(pagarmePlanId) {
	return (
		BILLING_PLANS.find((plan) => plan.pagarmePlanId === pagarmePlanId) || null
	);
}

export function getPlanByStoreProductId(storeProductId) {
	return (
		BILLING_PLANS.find((plan) => plan.storeProductId === storeProductId) ||
		null
	);
}

export function getPurchasablePlans() {
	return BILLING_PLANS.filter((plan) => plan.purchasable);
}

export function getStoreProductIds() {
	return getPurchasablePlans()
		.map((plan) => plan.storeProductId)
		.filter(Boolean);
}
